<mat-nav-list>
  @for (item of items(); track item) {
    <ng-container *ngIf="item.visible">
      @if (item.label !== 'PARAMÈTRAGE') {
        <a mat-list-item [routerLink]="item.route ? item.route : null"
            routerLinkActive #rla="routerLinkActive" [activated]="rla.isActive"
            (click)="item.subItems ? toggleParametrage() : null">
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          <span matListItemTitle>
            {{ item.label }}
          </span>
        </a>
      } @else {
        <a mat-list-item [routerLink]="item.route ? item.route : null"
           routerLinkActive #rla="routerLinkActive" [activated]="rla.isActive"
           (click)="item.subItems ? toggleParametrage() : null">
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          <span matListItemTitle>
           {{ item.label }}
            <mat-icon class="icon-arrow">
            {{ isParametrageExpanded ? 'arrow_drop_up' : 'arrow_drop_down' }}
          </mat-icon>
         </span>
        </a>
      }

      @if (item.label === 'ADMINISTRATION' && isParametrageExpanded) {
        <ng-container>
          @for (subItem of item.subItems; track subItem) {
            <a mat-list-item [routerLink]="subItem.route"
               routerLinkActive #subRla="routerLinkActive" [activated]="subRla.isActive">
              <mat-icon matListItemIcon>{{ subItem.icon }}</mat-icon>
              <span matListItemTitle>{{ subItem.label }}</span>
            </a>
          }
        </ng-container>
      }
    </ng-container>
  }

  <mat-icon (click)="toggleCollapseSidenav()" class="toggle-button">
    {{ collapsed ? 'east' : 'west' }}
  </mat-icon>
</mat-nav-list>
